import React from "react";

import capitalizeFirstLetter from "./utils/capitalizeFirstLetter";

type NotAvailableMessagesSectionProps = {
  hasAllergens: boolean;
  hasNutritionInfos: boolean;
  isFixedSideItem?: boolean;
};

export default function NotAvailableMessagesSection({
  hasAllergens,
  hasNutritionInfos,
  isFixedSideItem = false,
}: NotAvailableMessagesSectionProps): JSX.Element {
  const prefix = isFixedSideItem ? "side item " : "";
  const allergensInfoNotAvailable = capitalizeFirstLetter(
    prefix + "allergen information not available."
  );
  const nutritionInfoNotAvailable = capitalizeFirstLetter(
    prefix + "nutrition information is not currently available for this dish."
  );
  const bothInfoNotAvailable = capitalizeFirstLetter(
    prefix +
      "allergen and nutritional information is not yet available for this dish."
  );

  return (
    <>
      {!hasAllergens && !hasNutritionInfos && <b>{bothInfoNotAvailable}</b>}
      {!hasAllergens && hasNutritionInfos && <b>{allergensInfoNotAvailable}</b>}
      {hasAllergens && !hasNutritionInfos && <b>{nutritionInfoNotAvailable}</b>}
    </>
  );
}
